"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseApi_1 = __importDefault(require("./BaseApi"));
class BundleApi extends BaseApi_1.default {
    list(filters) {
        return this.http.get("/shop/api/v1/bundles/", {
            params: Object.assign({}, filters),
        });
    }
}
exports.default = BundleApi;
